import { useMemo } from "react";
import { AivArvActiveTab } from "../../../redux/types.ts";

// TODO: 582
export const useIndicatedCostByID = (
  aivArvTab?: AivArvActiveTab
) => useMemo(
  () =>
    ({ id }: { id: string }) => (
      <></>
    ),
  [aivArvTab]
)
